module.exports = __webpack_public_path__ + "img/1589305994.f45a42f5.jpg";